import { useCallback } from 'react';
import { useGlobalContext } from '../context/GlobalStore';
import { sortedOrders } from '../utils/queries';
import apiClient from '../utils/apiClient';

const useFetchOrders = () => {
  const { setIsOrderLoading, setOrders } = useGlobalContext();
  const fetchData = useCallback(
    async (accessToken, accountId) => {
      try {
        const response = await apiClient.get('/orders', {
          queryParams: {
            account_id: accountId,
          },
        }, true);
        if (response) {
          const sorted = sortedOrders(response);

          setOrders(sorted);
        }
      } catch (error) {
        console.error({ error });
      } finally {
        setIsOrderLoading(false);
      }
    },
    [setOrders, setIsOrderLoading]
  );

  return fetchData;
};

export default useFetchOrders;
